<div class="container">
    <div class="skill-box">
        <!-- <span class="title">Progress</span> -->
        <div class="skill-bar">
            <span class="skill-per progress" [style.width.%]="progress" [ngStyle]="{'background-color': truckIconColor}">
                <div class="truck-icon">
                    <i [ngClass]="truckIcon" [ngStyle]="{'color': truckIconColor}"></i>
                  </div>
            </span>
            <div class="status-text">{{ statusText }}</div>
        </div>
        
    </div>
    
</div>
  